import { render, staticRenderFns } from "./ProductListBlock.vue?vue&type=template&id=4ff3ce0c"
import script from "./ProductListBlock.vue?vue&type=script&lang=js"
export * from "./ProductListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports